import { FC, SVGProps } from 'react'

export const SoundwaveStar: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    {...props}
  >
    <path
      d="M6.9381 1.33877C7.49246 0.863605 7.76964 0.626022 8.08049 0.535472C8.35447 0.455665 8.64553 0.455665 8.91951 0.535472C9.23036 0.626022 9.50754 0.863605 10.0619 1.33877L10.3745 1.60669C10.6209 1.81794 10.7442 1.92357 10.883 1.99917C11.01 2.06831 11.1463 2.11873 11.2877 2.14887C11.4423 2.18182 11.6046 2.18182 11.9292 2.18182C12.7589 2.18182 13.1737 2.18182 13.4914 2.3414C13.7798 2.48624 14.0138 2.7202 14.1586 3.00855C14.3182 3.32627 14.3182 3.74112 14.3182 4.5708C14.3182 4.89542 14.3182 5.05773 14.3511 5.21233C14.3813 5.35373 14.4317 5.49003 14.5008 5.61701C14.5764 5.75583 14.6821 5.87906 14.8933 6.12553L15.1612 6.4381C15.6364 6.99246 15.874 7.26964 15.9645 7.58049C16.0443 7.85447 16.0443 8.14553 15.9645 8.41951C15.874 8.73036 15.6364 9.00754 15.1612 9.5619L14.8933 9.87447C14.6821 10.1209 14.5764 10.2442 14.5008 10.383C14.4317 10.51 14.3813 10.6463 14.3511 10.7877C14.3182 10.9423 14.3182 11.1046 14.3182 11.4292C14.3182 12.2589 14.3182 12.6737 14.1586 12.9914C14.0138 13.2798 13.7798 13.5138 13.4914 13.6586C13.1737 13.8182 12.7589 13.8182 11.9292 13.8182C11.6046 13.8182 11.4423 13.8182 11.2877 13.8511C11.1463 13.8813 11.01 13.9317 10.883 14.0008C10.7442 14.0764 10.6209 14.1821 10.3745 14.3933L10.0619 14.6612C9.50754 15.1364 9.23036 15.374 8.91951 15.4645C8.64553 15.5443 8.35447 15.5443 8.08049 15.4645C7.76964 15.374 7.49246 15.1364 6.9381 14.6612L6.62863 14.396C6.3791 14.1821 6.25433 14.0751 6.11358 13.999C5.98872 13.9314 5.85491 13.8819 5.71615 13.8519C5.5597 13.8182 5.39401 13.8182 5.06262 13.8182C4.22024 13.8182 3.79906 13.8182 3.47973 13.6566C3.19449 13.5123 2.96283 13.2806 2.81851 12.9954C2.65693 12.6761 2.65693 12.2586 2.65693 11.4236C2.65693 11.0997 2.65693 10.9377 2.6241 10.7834C2.59453 10.6444 2.54536 10.5103 2.47807 10.3852C2.40334 10.2462 2.29864 10.1226 2.08924 9.87551L1.81474 9.55156C1.34766 9.00035 1.11412 8.72474 1.02501 8.41624C0.946469 8.14431 0.946469 7.85569 1.02501 7.58376C1.11412 7.27526 1.34766 6.99966 1.81474 6.44844L2.08924 6.12449C2.29864 5.87738 2.40334 5.75382 2.47807 5.61484C2.54536 5.48969 2.59453 5.35561 2.6241 5.21662C2.65693 5.06228 2.65693 4.90033 2.65693 4.57642C2.65693 3.74143 2.65693 3.32394 2.81851 3.00461C2.96283 2.71938 3.19449 2.48771 3.47973 2.34339C3.79906 2.18182 4.22024 2.18182 5.06262 2.18182C5.39401 2.18182 5.5597 2.18182 5.71615 2.14805C5.85491 2.1181 5.98872 2.0686 6.11358 2.00103C6.25433 1.92486 6.3791 1.81792 6.62863 1.60403L6.9381 1.33877Z"
      fill="url(#paint0_linear_6993_446)"
    />
    <path
      d="M6.4707 5.97021L6.4707 10.0294"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.44141 7.59424L4.44141 8.40608"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 4.34668L8.5 11.6532"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5293 5.97021L10.5293 10.0294"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5605 7.59424L12.5605 8.40608"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6993_446"
        x1="-0.0853667"
        y1="20.2857"
        x2="25.5452"
        y2="7.15829"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFA2E5" />
        <stop offset="0.860316" stopColor="#B982FF" />
      </linearGradient>
    </defs>
  </svg>
)
